import React, {useState} from "react";
import {useAppSelector} from "../../../../hooks";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import EditJoin from "./EditJoin";
import {BackProjType} from "../../../../features/schemaManageSlice";
import EditField from "./EditField";
import EditOuterField from "./EditOuterField";
import EditPermaFilter from "./EditPermaFilter";
import EditFilter from "./EditFilter";
import EditUpd from "./EditUpd";


type AddNewPropsI = { type: "join" | "field" | "outerField" | "permaFilter" | "filter" | "updField", tableType: BackProjType };
export default function AddNew({type, tableType}: AddNewPropsI) {

    const [isAddingNew, setIsAddingNew] = useState(false)
    const closeEditing = () => setIsAddingNew(false);

    const mode = useAppSelector(state => state.schemaManage.back.mode);

    if (mode !== "edit" || tableType === "static")
        return null

    return <>
        <Container onClick={() => setIsAddingNew(true)}>
            <FontAwesomeIcon size={"lg"} icon={faPlus} className={'fa-color'}/>
        </Container>
        {isAddingNew && type === "join" &&
            <EditJoin addNew join={"join schema.table on a.id = fa.id"} joinKey={'new join key'}
                      closeEditing={closeEditing}/>}
        {isAddingNew && type === "field" &&
            <EditField addNew field={{}} fieldKey={"new_field"} closeEditing={closeEditing}/>}
        {isAddingNew && type === "outerField" &&
            <EditOuterField addNew field={{
                sql: "a.inner_field as new_outer_field",
                depends: []
            }} fieldKey={"new_outer_field"} closeEditing={closeEditing}/>}
        {isAddingNew && type === "permaFilter" &&
            <EditPermaFilter addNew filter={{
                sql: "a.some_field = 'STATIC_VALUE'",
                depends: []
            }} filterKey={"perma_filter_1"} closeEditing={closeEditing}/>}
        {isAddingNew && type === "filter" &&
            <EditFilter addNew filter={{
                type: "string",
                operationsList: [],
                appendAlias: true,
                outer: false
            }} filterKey={"new_filter"} closeEditing={closeEditing}/>}
        {isAddingNew && type === "updField" &&
            <EditUpd addNew type={"string"} fieldKey={"new_upd_field"} closeEditing={closeEditing}/>}
    </>
}

const Container = styled.button`
    padding: 0;
    appearance: none;
    border: none;
    background: none;
`
